import { useRef, useState,useEffect } from "react";
import SpeechRecognition, { useSpeechRecognition } from "react-speech-recognition";
import micro1 from '../../images/microphone_stop.png'
import micro2 from '../../images/microphone.png'
import './ConversationStyleSheet.css'

const TextToSpeech = props => {
  const { transcript,finalTranscript, resetTranscript } = useSpeechRecognition();
  const [isListening, setIsListening] = useState(false);
  const [text,setText] = useState("");
  // const [sent,isSent] = useState();
  const microphoneRef = useRef(null);

  const handleClick = () =>{
    let check = !isListening;
    resetTranscript();
    console.log("ckk",check)
    if(check) {
      setIsListening(true);
      console.log("listening",{transcript});
      microphoneRef.current.classList.add("listening");
      SpeechRecognition.startListening({
        continuous: true,
      });
    } else {
      stopHandle();
    }
  }

  const stopHandle = (data) => {
    setIsListening(false);
    
    microphoneRef.current.classList.remove("listening");
    SpeechRecognition.stopListening();
    resetTranscript();
  };

  useEffect(()=>{
    stopHandle();
  },[props.sent])

  useEffect(() => {
    console.log("t",props)
    if (isListening) {
      console.log("text..",text) 
      console.log("sub",finalTranscript.substr(text.length))
      let val = text.length>0?finalTranscript.substr(text.length):finalTranscript;
      console.log("textValue",props.textValue+" "+val) 
      props.setTextValue(props.textValue+" "+val)  
    }
    let str = finalTranscript
    setText(str)
  }, [finalTranscript]);

  return (
    <div className={localStorage.getItem("openInFullScreen") ?"microphone-wrapper-fs" : "microphone-wrapper"} style={{ ...props.style }}>
      {
        <div className="mircophone-container">
          <div className="microphone-icon-container" ref={microphoneRef} onClick={handleClick}>
            {
              isListening 
              ? <img src={micro2} style={{ height:"20px", width:"20px" }} className="microphone-icon" />
              : props.showOutlinedMic
              ? <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" className="microphone-icon" style={{ width: "32px", height: "32px" }}>
                  <circle 
                    cx="256" cy="256" r="256" 
                    fill={!!props.config.designDetails.sendIconColor
                      ? props.config.designDetails.sendIconColor
                      : "#000"
                    }
                  />
                  <rect x="196" y="128" width="120" height="180" rx="60" ry="60" fill="#fff"/>
                  <path d="M336 280c0 44.2-35.8 80-80 80s-80-35.8-80-80" fill="none" stroke="#fff" strokeWidth="20" strokeLinecap="round"/>
                  <line x1="256" y1="360" x2="256" y2="400" stroke="#fff" strokeWidth="20" strokeLinecap="round"/>
                  <line x1="216" y1="400" x2="296" y2="400" stroke="#fff" strokeWidth="20" strokeLinecap="round"/>
                </svg>
              : <img src={micro1} className="microphone-icon" />
            }
          </div>
        </div>
      }
    </div>
  );
};

export default TextToSpeech;
